<template>
  <div class="main" :class="{ lightMain: lightMode }">
    <div class="container">
      <div class="background-img">
        <svg
          x="0px"
          y="0px"
          viewBox="0 0 1064 1023"
          style="enable-background: new 0 0 800 801.1"
          xml:space="preserve"
        >
          <g>
            <path
              class="path"
              :class="{ lightPath: lightMode }"
              d="M918.5,511.3l137.4-252.9H865.8L832,320.7l-17.2-64.1L747,5.2H592.1L7.8,1017.2h176.9l461-798.3
	l55,205.8l23.2,86.6h-66.8L519.8,764.3h-71.2l-137.4,252.9h190.1l137.4-252.9h71.2l54.8-100.9l95.1,353.8h158.4L883.1,511.3
	L918.5,511.3z"
            />
          </g>
        </svg>
      </div>
      <div class="wallet-address" :class="{ lightWalletAddress: lightMode }">
        <div  class="container-wallet">
          <div class="algo-img"><img src="@/assets/icons/Algo.svg" /></div>
          <div class="title" :class="{ lightTitle: lightMode }">
            Your Wallet Address
          </div>
          <i class="material-icons" :class="{ lightMaterialIcons: lightMode }" v-on:click="toggle">
            link
          </i>
        </div>
        <div class="address" :class="{ lightAddress: lightMode }">
          <div class="input-container">
            <input
              type="text"
              class="input"
              :class="{ lightInput: lightMode }"
              placeholder="Wallet address"
              v-model="data.wallet"
            />
          </div>
          <span v-if="!data.calulating">
          <div class="button" :class="{ lightButton: lightMode }" v-on:click="processForm">
            Calculate
          </div>
          </span>
          <span v-else>
            <div class="button" :class="{ lightButton: lightMode }">
            Syncing
            </div>
          </span>
        </div>
      </div>
      <div class="connector" :class="{ lightConnector: lightMode }">
        <svg  x="0px" y="0px" viewBox="0 0 168.6 21.9" >
	        <line  class="path" x1="14.1" y1="11" x2="154.1" y2="11"/>
        </svg>
      </div>
      <div class="statistics">
        <h1 :class="{ lightH1: lightMode }">Blockchain Statistics</h1>
        <div class="row">
          <div class="column base_rate" :class="{ lightColumn: lightMode }">
            <div class="cell-title">Base Rate</div>
            <div class="cell-value" :class="{ lightCellValue: lightMode }">
              {{ data.baseRate }}
            </div>
          </div>
          <div class="column" :class="{ lightColumn: lightMode }">
            <div class="cell-title">Reward Rate</div>
            <div class="cell-value" :class="{ lightCellValue: lightMode }">
              <div class="container-algo">
                <div class="algo-img">
                  <img src="@/assets/icons/Algo.svg" />
                </div>
                <div class="amount">{{ data.rewardRateCorrected }}</div>
              </div>
            </div>
          </div>
          <div class="column" :class="{ lightColumn: lightMode }">
            <div class="cell-title">Average Block Time</div>
            <div class="cell-value" :class="{ lightCellValue: lightMode }">
              {{ data.averageTime }}
            </div>
          </div>
        </div>

        <h1 :class="{ lightH1: lightMode }">Your Statistics</h1>
        <div class="row">
          <div class="column2" :class="{ lightColumn: lightMode }">
            <div class="cell-title">Maximum Rate (APY)</div>
            <div class="cell-value2" :class="{ lightCellValue: lightMode }">
              {{ data.maxRate }}
            </div>
          </div>
          <div class="column2" :class="{ lightColumn: lightMode }">
            <div class="cell-title">Last Reset (UTC Time)</div>
            <div class="cell-value2" :class="{ lightCellValue: lightMode }">
              {{ data.lastReset }}
            </div>
          </div>
          <div class="column2" :class="{ lightColumn: lightMode }">
            <div class="cell-title">Next Compound (UTC Time)</div>
            <div class="cell-value2" :class="{ lightCellValue: lightMode }">
              {{ data.nextCompound }}
            </div>
          </div>
          <div class="column2" :class="{ lightColumn: lightMode }">
            <div class="cell-title">Balance Without Pending Rewards</div>
            <div class="cell-value2" :class="{ lightCellValue: lightMode }">
              <div class="container-algo">
                <div class="algo-img2">
                  <img src="@/assets/icons/Algo.svg" />
                </div>
                <div class="amount">{{ data.prerewardBalnace }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          
          

          <div class="column2" :class="{ lightColumn: lightMode }">
            <div class="cell-title">Best compounding schedule</div>
            <div class="cell-value2" :class="{ lightCellValue: lightMode }">
              {{ data.optimalTime }}
            </div>
          </div>
          <div class="column2" :class="{ lightColumn: lightMode }">
            <div class="cell-title">Maximum Algos EOY</div>
            <div class="cell-value2" :class="{ lightCellValue: lightMode }">
              <div class="container-algo">
                <div class="algo-img2">
                  <img src="@/assets/icons/Algo.svg" />
                </div>
                <div class="amount">{{ data.algoPerYear }}</div>
              </div>
            </div>
          </div>  
          <div class="column2" :class="{ lightColumn: lightMode }">
            <div class="cell-title">Maximum Algos per day</div>
            <div class="cell-value2" :class="{ lightCellValue: lightMode }">
              <div class="container-algo">
                <div class="algo-img2">
                  <img src="@/assets/icons/Algo.svg" />
                </div>
                <div class="amount">{{ data.algoPerDay }}</div>
              </div>
            </div>
          </div>
          <div class="column2" :class="{ lightColumn: lightMode }">
            <div class="cell-title">Maximum Algos per month</div>
            <div class="cell-value2" :class="{ lightCellValue: lightMode }">
              <div class="container-algo">
                <div class="algo-img2">
                  <img src="@/assets/icons/Algo.svg" />
                </div>
                <div class="amount">{{ data.algoPerMonth }}</div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, onUnmounted, reactive, computed } from "vue";
import { trueSecondsToHms, toFixed2, dateToStr } from "@/helpers";
import axios from "axios";
import store from "@/store";
import validate from "multicoin-address-validator";
export default {
  setup() {
    const lightMode = computed(() => store.getters.lightMode);
    const data = reactive({
      optimalTime: "#d#h#m#s",
      algoPerDay: "###",
      algoPerMonth: "###",
      algoPerYear: "###",
      wallet: "",
      calulating: false,
      baseRate: "0.00%",
      rewardRateCorrected: "0.00",
      averageTime: "0 seconds",
      prerewardBalnace: "0.00",
      lastReset: "",
      nextCompound: "",
      maxRate: "0.00%",
    });

    const loadCurrent = async () => {
      const response = await axios.get(
        "https://algooptimizer.com/service/optimal2/current"
      );
      return await response.data;
    };

    const getter = async () => {
      const response = await loadCurrent();

      data.baseRate = toFixed2(response.base_rate,2) + "%"
      data.rewardRateCorrected = toFixed2(response.blockchain_reward_rate_corrected,6)
      data.averageTime = toFixed2(response.avg_time,2) + " seconds"
    };

    let token;
    onMounted(() => {
      getter();
      token = window.setInterval(getter, 5000);
    });

    onUnmounted(() => {
      window.clearInterval(token);
    });

    const doRequest = async () => {
      const response = await axios.get(
        "https://algooptimizer.com/service/optimal2/" + data.wallet
      );
      return await response.data;
    };

    const processForm = async () => {
      const regex = new RegExp('[A-Z2-7]{58}');
      if (data.wallet != "" && regex.test(data.wallet)) {
        console.log(data.wallet);
        data.calulating = true
        const response = await doRequest();

        console.log(response);

        data.optimalTime = trueSecondsToHms(response.best_secs)
        data.algoPerYear = toFixed2(response.max_per_year, 6)
        data.algoPerMonth = toFixed2(response.max_per_month, 6)
        data.algoPerDay = toFixed2(response.max_per_day, 6)
        data.calulating = false
      
        data.prerewardBalnace = response.prereward_balnace
        data.lastReset = dateToStr(response.last_reset)
        data.nextCompound = dateToStr(response.next_compound)
        data.maxRate = toFixed2(response.max_rate,2) + "%"
      } else {
        console.log("Bad address");
      }
    };

    return { lightMode, data, processForm };
  },
};
</script>

<style lang="scss" scoped>
.main {
  position: relative;
  display: flex;
  position: relative;
  background-color: $background-standard;
  color: $body-text;
  overflow: hidden;
  @media (min-width: $desktop) {
    padding-left: 20px;
  }
  @media (min-width: $large-desktop) {
    flex-direction: row;
  }
}

.lightMain {
  background-color: $background-standard-light;
  color: $body-text-light;
}

.container {
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  justify-content: space-between;
  max-width: $large-desktop;
  margin: auto;
  @media (min-width: $large-desktop) {
    flex-direction: row;
  }
}

.title {
  opacity: 0.68;
  margin-left: -20px;
}

.lightTitle {
  color: $white;
}

.wallet-address {
  width: 413px;
  background-color: $black;
  text-align: center;
  padding-top: 21px;
  margin-top: 50px;
  margin-bottom: 100px;
  box-shadow: 0px 3px 6px $box-shadow;
  border-radius: 10px;
  padding-right: 15px;
  padding-left: 15px;
  @media (min-width: $large-desktop) {
    margin-top: 111px;
    margin-bottom: 154px;
    margin-right: 0;
  }
}

.lightWalletAddress {
  background-color: $body-text-accented-light;
  box-shadow: 0px 3px 6px $box-shadow-light;
}

.container-wallet {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.container-algo {
  display: flex;
  align-items: center;
  margin-left: -20px;
}

.algo-img {
  position: relative;
  top: -2px;
  margin-bottom: -40px;
  margin-top: -30px;
  img {
    width: 40px;
    margin-left: 5px;
    margin-right: 10px;
    @media (min-width: 1455px) {
      width: 70px;
      margin-left: 0;
      margin-right: 0;
    }
  }
}

.algo-img2 {
  margin-bottom: -40px;
  margin-top: -30px;
  img {
    width: 30px;
    margin-left: 5px;
    margin-right: 10px;
    @media (min-width: 1455px) {
      width: 50px;
      margin-left: 0;
      margin-right: 0;
    }
  }
}

.address {
  margin-top: 58px;
  font-size: 0.875rem;
}

.message {
  margin-top: 58px;
  margin-bottom: 58px;
  padding-left: 10px;
  padding-right: 10px;
  font-size: 0.875rem;
}

.balance_header {
  margin-top: 40px;
  margin-bottom: 5px;
  font-size: 0.875rem;
}

.balance_block {
  display: inline-block;
  align-items: center;
  height: 26px;
  padding-top: 8px;
  padding-left: 5px;
  padding-right: 10px;
  margin-bottom: 20px;
  background: $background-statistics 0% 0% no-repeat;
  box-shadow: 0px 3px 6px $box-shadow;
  border-radius: 10px;
}

.algo-value {
  display: inline-flex;
  align-items: center;
  line-height: 1.5;
  img {
    width: 30px;
    margin-right: -5px;
  }
}

.reward {
  padding-bottom: 5px;
}


.lightAddress {
  color: $white;
}

.material-icons {
  font-size: 2rem;
  color: $highlight;
  cursor:pointer;
}

.lightMaterialIcons {
  color: $highlight-light;
}

.statistics {
  position: relative;
  z-index: 1;
  margin-top: -10px;
  margin-bottom: 60px;
  @media (min-width: $large-desktop) {
    margin-bottom: 0;
  }
}

.row {
  display: flex;
  flex-direction: column;
  @media (min-width: $large-desktop) {
    flex-direction: row;
  }
}

.column {
  display: flex;
  flex-direction: column;
  background: $background-statistics 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px $box-shadow;
  border-radius: 10px;
  width: 300px;
  height: 82px;
  margin-right: 16px;
  margin-bottom: 14px;
  padding: 9px 0 11px 15px;
  @media (min-width: $desktop) {
    width: 340px;
    margin-left: 20px;
  }
  @media (min-width: 1255px) {
    margin-left: 0;
    width: 250px;
  }
  @media (min-width: 1455px) {
    width: 340px;
  }
}

.column2 {
  display: flex;
  flex-direction: column;
  background: $background-statistics 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px $box-shadow;
  border-radius: 10px;
  width: 250px;
  height: 82px;
  margin-right: 16px;
  margin-bottom: 14px;
  padding: 9px 0 11px 15px;
  @media (min-width: $desktop) {
    width: 250px;
    margin-left: 20px;
  }
  @media (min-width: 1255px) {
    margin-left: 0;
    width: 250px;
  }
  @media (min-width: 1455px) {
    width: 250px;
  }
}

.base_rate {
  width: 140;
  @media (min-width: $desktop) {
    width: 140px;
    margin-left: 20px;
  }
  @media (min-width: 1255px) {
    margin-left: 0;
    width: 140px;
  }
  @media (min-width: 1455px) {
    width: 140px;
  }
}

.lightColumn {
  background: $background-statistics-light 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px $box-shadow-light;
}

.cell-title {
  font-size: 0.875rem;
}

.cell-value {
  color: $highlight;
  font-size: 1.35rem;
  @media (min-width: 1455px) {
    font-size: 1.8125rem;
  }
  .container {
    justify-content: flex-start;
    margin-left: -20px;
  }
}

.cell-value2 {
  color: $highlight;
  font-size: 1.3125rem;
  @media (min-width: 1455px) {
    font-size: 1.3125rem;
  }
  .container {
    justify-content: flex-start;
    margin-left: -20px;
  }
}

@-moz-document url-prefix() {
  .cell-value {
    line-height: 2;
  }
}

.lightCellValue {
  color: $highlight-light;
}

.amount {
  margin-left: -13px;
}

.superscript {
  font-size: 1.3rem;
  margin-left: 7px;
}

.connector {
  display: none;
  color: $highlight;
  white-space: nowrap;
  padding-left: 15px;
  padding-right: 15px;
  width: 200px;
  @media (min-width: $large-desktop) {
    display: block;
  }
}

.lightConnector {
  color: $highlight-light;
}

.background-img {
  position: absolute;
  top: -110px;
  right: -70px;
  z-index: 0;
  height: 100%;
  width: 700px;
  display: none;
  @media (min-width: $large-desktop) {
    display: block;
  }
}

h1 {
  font-size: 1.875rem;
  font-weight: 600;
  color: $body-text-accented;
  text-align: center;
  @media (min-width: $large-desktop) {
    text-align: left;
  }
}

.lightH1 {
  color: $body-text-accented-light;
}

.path {
  fill: none;
  stroke: $algo-img-background;
  stroke-miterlimit: 10;
}

.lightPath {
  stroke: $algo-img-background-light;
}

@keyframes dash {
  to {
    stroke-dashoffset: 1000;
  }
}

.path {
  animation: dash 40s linear infinite;
  stroke-dasharray: 4;
  fill:none;
  stroke: $selected-link;
  stroke-miterlimit:10;
}

.address-section {
  display: inline-block;
  padding: 10px 10px 5px 10px;
  margin-bottom: 10px;
  font-size: 0.875rem;
  .title {
    opacity: 0.68;
    margin-bottom: 9px;
  }
  .address {
    margin-top: 0px;
    text-align: center;
    width: 290px;
    margin-bottom: 5px;
  }
  .copy {
    color: $highlight;
    cursor: pointer;
  }
  .lightCopy {
    color: $highlight-light;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.lightButton {
  background: $background-button-light 0% 0% no-repeat padding-box;
  color: $background-standard-light;
  box-shadow: 0px 3px 6px $box-shadow-light;
  &:hover {
    background: darken($background-button-light, 10%);
  }
}

.input-container {
  display: flex;
  align-items: center;
}

input {
  width: 100%;
  height: 42px;
  display: inline-block;
  margin-top: 10px;
  margin-bottom: 26px;
  border-radius: 10px;
  box-shadow: 0px 3px 6px $box-shadow;
  font-size: 0.875rem;
  padding-left: 20px;
  padding-right: 20px;
  border: none;
  color: $body-text-accented;
  background-color: $background-standard;
  font-family: "Overpass", sans-serif;
  outline: none;
  @media (min-width: $large-desktop) {
    width: 460px;
  }
  &::placeholder {
    color: $body-text-accented;
  }
}

.lightInput {
  box-shadow: 0px 3px 6px $box-shadow-light;
  background: $white;
  color: $body-text-accented-light;
  &::placeholder {
    color: $body-text-accented-light;
  }
}

.button {
  display: inline-block;
  width: 120px;
  height: 42px;
  background: $highlight 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px $box-shadow;
  border-radius: 10px;
  color: $background-standard;
  padding-top: 8px;
  margin-bottom: 15px;
  margin-left: -4px;
  cursor: pointer;
  line-height: 1.7;
  &:hover {
    background: darken($highlight, 10%);
  }
}

</style>
